import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  if (!token) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6', padding: 16 }}>
        <div style={{ width: '100%', maxWidth: 400 }}>
          <div style={{ background: 'white', padding: 32, borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', textAlign: 'center' }}>
            <h2 style={{ margin: '0 0 12px', fontSize: 20, fontWeight: 600, color: '#dc2626' }}>Invalid Reset Link</h2>
            <p style={{ color: '#6b7280', fontSize: 14, lineHeight: 1.5, marginBottom: 20 }}>
              This password reset link is invalid. Please request a new one.
            </p>
            <Link to="/forgot-password" style={{ color: '#b91c1c', fontWeight: 500 }}>Request New Reset Link</Link>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 10) {
      setError('Password must be at least 10 characters with uppercase, lowercase, number, and special character');
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      setSuccess(true);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ background: '#b91c1c', color: 'white', display: 'inline-block', padding: '12px 24px', borderRadius: 12, fontSize: 24, fontWeight: 700, marginBottom: 8 }}>
            PPE Tracker
          </div>
        </div>

        <div style={{ background: 'white', padding: 32, borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          {success ? (
            <>
              <div style={{ textAlign: 'center', marginBottom: 16 }}>
                <div style={{ fontSize: 40, marginBottom: 8, color: '#16a34a' }}>&#10003;</div>
                <h2 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 600 }}>Password Reset!</h2>
                <p style={{ color: '#6b7280', fontSize: 14, lineHeight: 1.5, margin: 0 }}>
                  Your password has been updated. You can now sign in with your new password.
                </p>
              </div>
              <button onClick={() => navigate('/login')}
                style={{ width: '100%', padding: '12px', background: '#b91c1c', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 16 }}>
                Go to Sign In
              </button>
            </>
          ) : (
            <>
              <h2 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 600 }}>Set New Password</h2>
              <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 20, lineHeight: 1.4 }}>
                Choose a new password for your account.
              </p>

              {error && <div style={{ background: '#fef2f2', color: '#b91c1c', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 14 }}>{error}</div>}

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 6, color: '#374151' }}>New Password</label>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)} required autoFocus
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
                    placeholder="At least 10 characters" />
                </div>

                <div style={{ marginBottom: 24 }}>
                  <label style={{ display: 'block', fontSize: 14, fontWeight: 500, marginBottom: 6, color: '#374151' }}>Confirm Password</label>
                  <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required
                    style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
                    placeholder="Confirm your new password" />
                </div>

                <button type="submit" disabled={loading}
                  style={{ width: '100%', padding: '12px', background: '#b91c1c', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
                  {loading ? 'Resetting...' : 'Reset Password'}
                </button>
              </form>

              <p style={{ marginTop: 20, textAlign: 'center', fontSize: 14, color: '#666' }}>
                <Link to="/login" style={{ color: '#b91c1c', fontWeight: 500 }}>Back to Sign In</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
